import React from "react";
import { styled } from "@mui/material/styles";
import { CheckOutlined } from "@ant-design/icons";
import moment from "moment";
import StatusTag from "../StatusTag";

interface PageTagProps {
  title: string;
  studyAlias: string;
  status: string;
  updateAt?: string;
  author?: string;
  createdAt?: string;
}

export function checkIfStringIsUnixTimestamp(value: string) {
  return /^\d+$/.test(value);
}

const PageTag: React.FC<PageTagProps> = ({
  title,
  studyAlias,
  status,
  updateAt,
  author,
  createdAt,
}) => (
  <Title>
    <div className="title">
      {title}: {studyAlias}
    </div>
    <StatusTag
      status={status}
      style={{ color: "#252525", fontSize: "0.75rem" }}
    />
    <span>
      {createdAt ? (
        <span className="creation-time">
          Created At{" "}
          {checkIfStringIsUnixTimestamp(createdAt)
            ? moment(Number(createdAt)).format("MMM D, YYYY hh:mm A")
            : moment(createdAt).format("MMM D, YYYY hh:mm A")}
        </span>
      ) : (
        ""
      )}
      {(updateAt || author) && (
        <span className="updator">
          <CheckOutlined /> Last saved{" "}
          {updateAt
            ? checkIfStringIsUnixTimestamp(updateAt)
              ? moment(Number(updateAt)).format("MMM D, YYYY hh:mm A")
              : moment(updateAt).format("MMM D, YYYY hh:mm A")
            : ""}{" "}
          by {author || "-"}
        </span>
      )}
    </span>
  </Title>
);
const Title = styled("div")({
  "& .title": {
    color: "#000000",
    fontSize: "1.5rem",
  },
  "& .updator": {
    display: "block",
    color: "#A59D95",
    fontSize: "1rem",
    marginTop: "10px",
  },
  "& .creation-time": {
    display: "block",
    color: "#A59D95",
    fontSize: "1rem",
    marginTop: "10px",
  },
});
export default PageTag;
